import { NicScope } from '../../../../nic-react-monorepo/packages/nic-api/types'
export const assigmentViewParam = (realm: NicScope) =>
  realm === 'registrar' ? 'registrarAssignation' : 'registryAssignation'
